/**
 * Fecha de envío / "Fecha Transfer." para tablas y detalle:
 * 1) WIP transferredAt (GEMA FECHAENVIO / TRL send) — preferred
 * 2) Else linked transfer lifecycle dates
 * 3) Else firstAssignedAt (legacy / reception compat)
 */
export type TransferLike =
  | {
      status?: string;
      createdAt?: string;
      completedAt?: string | null;
      cancelledAt?: string | null;
    }
  | null
  | undefined;

export function getTransferDisplayAtIso(
  transfer: TransferLike,
  productFirstAssignedAt?: string | null,
  productTransferredAt?: string | null,
): string | undefined {
  if (productTransferredAt != null && productTransferredAt !== '') {
    return productTransferredAt;
  }
  if (!transfer) {
    return productFirstAssignedAt != null && productFirstAssignedAt !== ''
      ? productFirstAssignedAt
      : undefined;
  }
  const s = (transfer.status || '').toUpperCase();
  if (s === 'COMPLETED') {
    // Prefer send (createdAt) over completedAt — completedAt is reception.
    if (transfer.createdAt) return transfer.createdAt;
    if (productFirstAssignedAt) return productFirstAssignedAt;
    return transfer.completedAt ?? undefined;
  }
  if (s === 'CANCELLED') {
    if (transfer.cancelledAt) return transfer.cancelledAt;
    return transfer.createdAt;
  }
  return transfer.createdAt;
}

const esDateTime: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export function formatTransferEventDateEs(transfer: TransferLike): string {
  const iso = getTransferDisplayAtIso(transfer);
  if (!iso) return 'N/A';
  return new Date(iso).toLocaleString('es-ES', esDateTime);
}
